import { useState } from "react";
import { themeColours } from "../../resources";
import "./HomePageGuide.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { InfoModal } from "./InfoModal";
const homePagePng = require("../../assets/homePage.png");

export function HomePageGuide() {
  const navigate = useNavigate();
  const [feedbackCheck, setFeedbackCheck] = useState<boolean>(localStorage.getItem("feedbackCheck") === "T");
  const [priceCheck, setPriceCheck] = useState<boolean>(localStorage.getItem("priceCheck") === "T");
  const [recentsCheck, setRecentsCheck] = useState<boolean>(localStorage.getItem("recentsCheck") === "T");
  function handleIconClick(icon: string) {
    switch (icon) {
      case "shop":
        localStorage.setItem("shopCheck", "T");
        return navigate("/guide/shop");
      case "template":
        localStorage.setItem("templateCheck", "T");
        return navigate("/guide/template");
      case "feedback":
        localStorage.setItem("feedbackCheck", "T");
        setFeedbackCheck(true);
        break;
      case "price":
        localStorage.setItem("priceCheck", "T");
        setPriceCheck(true);
        break;
      case "recents":
        localStorage.setItem("recentsCheck", "T");
        setRecentsCheck(true);
    }
  }
  return (
    <div className="homePageContainer">
      <img src={homePagePng} alt="background" className="background" />
      <InfoModal
        element={
          <span className="infoIcon shopIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={localStorage.getItem("shopCheck") === "T" ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Shops"}
        texts={[
          <h5 className="modalInfo">
            Either start a <strong className="extraBold">new shop</strong> with an empty cart or load a{" "}
            <strong className="extraBold">saved shop template</strong>. Completed shops will appear under 'Recent
            shops'.
          </h5>,
        ]}
        buttonText="Learn more"
        onButtonClick={() => handleIconClick("shop")}
      />
      <InfoModal
        element={
          <span className="infoIcon templateIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={localStorage.getItem("templateCheck") === "T" ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Templates"}
        texts={[
          <h5 className="modalInfo">
            Designed to make filling up your cart quicker by using a{" "}
            <strong className="extraBold">previous shop</strong> as a base, from which you can make any necessary
            adjustments.
          </h5>,
          <h5 className="modalInfo">
            Templates work by saving the item criteria of previous shops, and when used, the current{" "}
            <strong className="extraBold">best value</strong> items meeting these criteria are{" "}
            <strong className="extraBold">automatically</strong> added to your starting cart.
          </h5>,
          <h5 className="modalInfo">
            If you wish to <strong className="extraBold">edit</strong> the item criteria in a template, load the
            template as a <strong className="extraBold">new</strong> shop, <strong className="extraBold">adjust</strong>{" "}
            the item criteria for the items in your cart, <strong className="extraBold">complete</strong> the shop and{" "}
            <strong className="extraBold">save</strong>.
          </h5>,
        ]}
        buttonText="Learn more"
        onButtonClick={() => handleIconClick("template")}
      />
      <InfoModal
        element={
          <span className="infoIcon feedbackIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={feedbackCheck ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Feeback"}
        texts={[
          <h5 className="modalInfo">
            Send us feedback on any categories that need <strong className="extraBold">cleaning up</strong>, categories
            that need <strong className="extraBold">additional items</strong> added to them, any{" "}
            <strong className="extraBold">new</strong> categories and sub-categories that you would like added, etc. Any
            feedback is <strong className="extraBold">greatly appreciated</strong> as we try to maximise the usefulness
            of the app.
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("feedback")}
      />
      <InfoModal
        element={
          <span className="infoIcon priceIcon">
            <IoMdInformationCircleOutline size={20} color={priceCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Price History"}
        texts={[
          <h5 className="modalInfo">
            Track the <strong className="extraBold">trend</strong> in prices over time allowing you to assess whether a
            current <strong className="extraBold">sale</strong> price is <strong className="extraBold">actually</strong>{" "}
            a discounted price - no more being caught out by discounts applied to{" "}
            <strong className="extraBold">inflated</strong> prices!
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("price")}
      />
      <InfoModal
        element={
          <span className="infoIcon recentsIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={recentsCheck ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Recent Shops"}
        texts={[
          <h5 className="modalInfo">
            Shows your history of <strong className="extraBold">completed</strong> shops, how many{" "}
            <strong className="extraBold">items</strong> were in your cart and the{" "}
            <strong className="extraBold">total savings</strong> for the shop (find out how these savings are calculated
            in the “Shop” section).
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("recents")}
      />
    </div>
  );
}
